import { EN_LANG, I18N_REDIRECTED, VI_LANG } from 'constants';
import Cookies from 'helpers/cookies';
import { useTranslation } from 'react-i18next';
import { domUtils } from 'utils';

const useLang = () => {
  const locate =
    localStorage?.getItem(I18N_REDIRECTED) ||
    Cookies.get(I18N_REDIRECTED) ||
    domUtils.getQueryWithName('lang') ||
    EN_LANG;

  const { t } = useTranslation(locate);

  const isVi = locate === VI_LANG;
  const isEn = locate === EN_LANG;

  return { t, locate, isVi, isEn };
};

export default useLang;
